<div mdbModal #seleccionarCliente="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Ver clientes
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">

                <div class="row" *ngIf="listaClientes.length === 0">
                    <div class="col">
                        <a mdbBtn color="info" class="waves-light" mdbWavesEffect>
                            No existen registros para el filtro seleccionado</a>
                    </div>
                </div>

                <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaClientes.length > 0">
                    <thead class="grey lighten-2">
                        <tr>
                            <th scope="col" class="text-center">RUT</th>
                            <th scope="col" class="text-center">Nombre</th>
                            <th scope="col" class="text-center" *ngIf="mode === 'RUT_SUCURSAL'">Sucursal</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let cliente of listaClientes; trackBy: trackByClienteRut">
                            <td>{{ cliente.rutFormato | rut }}</td>
                            <td>{{ cliente.razon_social }}</td>
                            <td *ngIf="mode === 'RUT_SUCURSAL'">{{ cliente.direccion_completa }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                    (click)="seleccionarCliente.hide()" mdbWavesEffect>Cerrar</button>
            </div>
        </div>
    </div>
</div>